export const AvatarNavbarSportsActivitiesIcon = ({
  className = '',
}: {
  className?: string
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1460_91960)">
        <path
          d="M1.25 12.15C2.23 12.51 3.28 12.71 4.38 12.71C6.59 12.71 8.66 11.6 10.21 10.21"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M17.63 15.59C17.24 14.63 16.69 13.71 15.96 12.89C14.48 11.24 12.27 10.43 10.21 10.21"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M10.06 1.05C9.52 1.93 9.12 2.92 8.9 4C8.47 6.17 9.15 8.42 10.21 10.21"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M14.65 11.75C13.07 14.95 10.69 17.07 3.88 16.84"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M6.19 12.47C3.75 9.55 3.83 5.17 4.75 2.85"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M8.78 5.76C12.15 4.99 15.26 5.56 19.36 10.8"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M10.21 19.37C15.27 19.37 19.37 15.27 19.37 10.21C19.37 5.15 15.27 1.04 10.21 1.04C5.15 1.04 1.04 5.15 1.04 10.21C1.04 15.27 5.15 19.37 10.21 19.37Z"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_1460_91960">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
